module.exports = __webpack_public_path__ + "img/e8e7812.png";